import { createContext } from 'react';
import { CoursePricingOption } from '../../../../../../store/features/coursePricing';
import {
  CourseOptionAllFilterOption,
  CourseOptionFilterType,
} from '../../constants';
import {
  CourseOptionDisplayModuleSection,
  CourseOptionFilter,
} from '../../types';

export type CourseOptionDisplayModuleFilterOption = {
  shown: boolean;
  options: CourseOptionFilter[];
};

export type CourseOptionDisplayModuleSelectedFilters = {
  [CourseOptionFilterType.DELIVERY_TYPE]: CourseOptionFilter['value'];
  [CourseOptionFilterType.LANGUAGE]: CourseOptionFilter['value'];
  [CourseOptionFilterType.CURRENCY]: CourseOptionFilter['value'];
};

export type CourseOptionDisplayModuleFilters = {
  [CourseOptionFilterType.DELIVERY_TYPE]: CourseOptionDisplayModuleFilterOption;
  [CourseOptionFilterType.LANGUAGE]: CourseOptionDisplayModuleFilterOption;
  [CourseOptionFilterType.CURRENCY]: CourseOptionDisplayModuleFilterOption;
};

export type CourseOptionDisplayModuleContextProps = {
  section: CourseOptionDisplayModuleSection;
  rows: CoursePricingOption[];
  filters: CourseOptionDisplayModuleFilters;
  selectedFilters: CourseOptionDisplayModuleSelectedFilters;
  showMore: boolean;
  handleShowMoreClick: () => void;
  handleFilterChange: (
    filter: CourseOptionFilter['value'],
    filterKey: CourseOptionFilterType,
  ) => void;
};

export const CourseOptionDisplayModuleContext =
  createContext<CourseOptionDisplayModuleContextProps>({
    section: {} as CourseOptionDisplayModuleSection,
    rows: [],
    filters: {
      [CourseOptionFilterType.DELIVERY_TYPE]: {
        shown: false,
        options: [],
      },
      [CourseOptionFilterType.LANGUAGE]: {
        shown: false,
        options: [],
      },
      [CourseOptionFilterType.CURRENCY]: {
        shown: false,
        options: [],
      },
    },
    selectedFilters: {
      [CourseOptionFilterType.DELIVERY_TYPE]: CourseOptionAllFilterOption,
      [CourseOptionFilterType.LANGUAGE]: CourseOptionAllFilterOption,
      [CourseOptionFilterType.CURRENCY]: CourseOptionAllFilterOption,
    },
    showMore: false,
    handleShowMoreClick: () => undefined,
    handleFilterChange: () => undefined,
  });
